module.exports = "/_next/static/images/b3805ca8c93740367ad6ea0db2a819e2-pj-person-making-card-purchase@3x.jpg.webp";